/**
 * Query key factory for booking field queries
 */
export const fieldQueryKeys = {
	service: (id: number) => ['service', id],

	monthAvailability: (
		serviceId: number,
		year: number,
		month: number,
		resources: number[],
		resourceMode: 'any' | 'all'
	) => [
		'month-availability',
		serviceId,
		year,
		month,
		resources,
		resourceMode,
	],

	timeSlots: (
		serviceId: number,
		date: string, // ISO date string for consistency
		resources: number[],
		duration: number,
		slotMode: 'aligned' | 'flexible',
		interval: number,
		resourceMode: 'any' | 'all'
	) => [
		'time-slots',
		serviceId,
		date,
		resources,
		duration,
		slotMode,
		interval,
		resourceMode,
	],
};
